/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteVectorStoreRequest = {
  vectorStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteVectorStoreRequest$inboundSchema: z.ZodType<
  DeleteVectorStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteVectorStoreRequest$Outbound = {
  vector_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteVectorStoreRequest$outboundSchema: z.ZodType<
  DeleteVectorStoreRequest$Outbound,
  z.ZodTypeDef,
  DeleteVectorStoreRequest
> = z.object({
  vectorStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteVectorStoreRequestToJSON(
  deleteVectorStoreRequest: DeleteVectorStoreRequest,
): string {
  return JSON.stringify(
    DeleteVectorStoreRequest$outboundSchema.parse(deleteVectorStoreRequest),
  );
}
export function deleteVectorStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteVectorStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteVectorStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteVectorStoreRequest' from JSON`,
  );
}
